import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { Switch } from 'types';

export const deleteSwitch = (switchId: number) => {
  return axios.delete(`/api/switches/${switchId}`);
};

type UseDeleteSwitchOptions = {
  config?: MutationConfig<typeof deleteSwitch>;
};

export const useDeleteSwitch = ({ config }: UseDeleteSwitchOptions) => {
  return useMutation({
    onMutate: async (deletedSwitchId: number) => {
      await queryClient.cancelQueries(['switches']);

      const previousSwitches = queryClient.getQueryData<Switch[]>(['switches']);

      queryClient.setQueryData(
        ['switches'],
        previousSwitches?.filter(
          (analyzerSwitch) => analyzerSwitch.id !== deletedSwitchId
        )
      );

      return { previousSwitches };
    },
    onError: (_, __, context: any) => {
      if (context?.previousSwitches) {
        queryClient.setQueryData(['switches'], context.previousSwitches);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['switches']);
      queryClient.invalidateQueries(['systemOverview']);
    },
    ...config,
    mutationFn: deleteSwitch,
  });
};
